var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Injectable } from '@angular/core';
import { AngularFire } from 'angularfire2';
import { BehaviorSubject } from 'rxjs';
import { AuthService } from './auth.service';
import { ServiceBase } from './base.service';
import { HayDayItems } from '../models/haydayitem';
export var PostService = (function (_super) {
    __extends(PostService, _super);
    function PostService(af, auth) {
        _super.call(this);
        this.af = af;
        this.auth = auth;
        this.searchValue = new BehaviorSubject(0);
        this.searchTerm = new BehaviorSubject('state');
        this.previousSearchValue = 0;
        this.previousSearchTerm = 'state';
    }
    PostService.prototype.getSearchResults = function () {
        var path = '/posts/';
        return this.af.database.list(path, {
            query: {
                orderByChild: this.searchTerm,
                equalTo: this.searchValue
            }
        });
    };
    PostService.prototype.filterPosts = function (itemLooking, itemSelling) {
        var _this = this;
        var nextSearchTerm = 'state';
        var nextSearchValue = 0;
        if (itemLooking == HayDayItems.None && itemSelling == HayDayItems.None) {
            nextSearchTerm = 'state';
            nextSearchValue = 0;
        }
        else if (itemLooking != HayDayItems.None && itemSelling != HayDayItems.None) {
            nextSearchTerm = 'searchStateLS';
            nextSearchValue = "0 " + itemSelling.id + " " + itemLooking.id;
        }
        else if (itemLooking != HayDayItems.None) {
            nextSearchTerm = 'searchStateS';
            nextSearchValue = "0 " + itemLooking.id;
        }
        else if (itemSelling != HayDayItems.None) {
            nextSearchTerm = 'searchStateLF';
            nextSearchValue = "0 " + itemSelling.id;
        }
        this.previousSearchTerm = this.searchTerm.getValue();
        this.previousSearchValue = this.searchValue.getValue();
        if (this.previousSearchTerm != nextSearchTerm && this.previousSearchValue != nextSearchValue) {
            this.searchTerm.next(nextSearchTerm);
            setTimeout(function () {
                _this.searchValue.next(nextSearchValue);
            }, 200);
        }
        else if (this.previousSearchTerm != nextSearchTerm) {
            this.searchTerm.next(nextSearchTerm);
        }
        else if (this.previousSearchValue != nextSearchValue) {
            this.searchValue.next(nextSearchValue);
        }
        else {
            this.searchValue.next(nextSearchValue);
        }
    };
    PostService.prototype.getPostById = function (key) {
        return this.af.database.object('/posts/' + key + '/');
    };
    PostService.prototype.createPost = function (post) {
        var newPostKey = firebase.database().ref().child('posts').push().key;
        var updates = {};
        updates['/posts/' + newPostKey] = post;
        updates['/user-posts/' + this.auth.id + '/' + newPostKey] = post;
        return firebase.database().ref().update(updates);
    };
    PostService.prototype.deletePost = function (post) {
        var updates = {};
        updates['/posts/' + post.$key] = null;
        updates['/user-posts/' + post.owner + '/' + post.$key] = null;
        updates['/post-messages/' + post.$key] = null;
        updates['/post-traders/' + post.$key] = null;
        return firebase.database().ref().update(updates);
    };
    PostService.prototype.joinPost = function (post, trader) {
        var updates = {};
        var postKey = post.$key;
        this.cleanPost(post);
        var traderKey = trader.$key;
        _super.prototype.cleanFirebaseObject.call(this, trader);
        if (post.traderCount >= 0) {
            post.traderCount += 1;
        }
        else {
            post.traderCount = 1;
        }
        if (post.state == 0 && post.traderCount == 5) {
            post.searchStateLS = "5 " + post.lookingFor + " " + post.selling;
            post.searchStateLF = "5 " + post.lookingFor;
            post.searchStateS = "5 " + post.selling;
        }
        updates['/posts/' + postKey] = post;
        updates['/user-posts/' + post.owner + '/' + postKey] = post;
        updates['/joined-posts/' + traderKey + '/' + postKey] = post;
        updates['/post-traders/' + postKey + '/' + traderKey] = trader;
        return firebase.database().ref().update(updates);
    };
    PostService.prototype.leavePost = function (post, trader) {
        var updates = {};
        var postKey = post.$key;
        this.cleanPost(post);
        if (post.state == 5 && post.traderCount == 5) {
            post.searchStateLS = "0 " + post.lookingFor + " " + post.selling;
            post.searchStateLF = "0 " + post.lookingFor;
            post.searchStateS = "0 " + post.selling;
        }
        if (post.traderCount > 0) {
            post.traderCount -= 1;
        }
        else {
            post.traderCount = 0;
        }
        updates['/posts/' + postKey] = post;
        updates['/user-posts/' + post.owner + '/' + postKey] = post;
        updates['/joined-posts/' + trader + '/' + postKey] = null;
        updates['/post-traders/' + postKey + '/' + trader] = null;
        return firebase.database().ref().update(updates);
    };
    PostService.prototype.getTraders = function (post) {
        return this.af.database.list('/post-traders/' + post.$key + '/');
    };
    PostService.prototype.getTraderDetailsById = function (post, traderId) {
        return this.af.database.object('/post-traders/' + post.$key + '/' + traderId);
    };
    PostService.prototype.updateTraderDetails = function (post, trader) {
        var updates = {};
        var traderKey = trader.$key;
        _super.prototype.cleanFirebaseObject.call(this, trader);
        updates['/post-traders/' + post.$key + '/' + traderKey] = trader;
        return firebase.database().ref().update(updates);
    };
    PostService.prototype.cleanPost = function (post) {
        _super.prototype.cleanFirebaseObject.call(this, post);
    };
    PostService = __decorate([
        Injectable(), 
        __metadata('design:paramtypes', [AngularFire, AuthService])
    ], PostService);
    return PostService;
}(ServiceBase));
